import { useMemo } from 'react';
import PropTypes from 'prop-types';
import TextField from 'src/components/ui/TextField';

import FilterPlate from '..';
import {
	FILTER_CLAUSE,
	filterContains,
	filterEmpty,
	filterEq,
	filterInRange,
	filterLess,
	filterMore,
	filterNotContains,
	filterNotEmpty,
	filterNotEq,
} from '../constants';
import RangeField from 'src/components/ui/RangeField';
import { useFilter } from 'src/hooks/filters/useFilter';
// import FilterPlateCDefault from './FilterPlateCDefault';

const FilterPlateCString = (props) => {
	const { initialSelected, operator, onSubmit, isNumber, ...rest } = props;

	const options = useMemo(() => {
		if (isNumber) {
			return [
				filterEq,
				filterNotEq,
				filterMore,
				filterLess,
				filterInRange,
				filterEmpty,
				filterNotEmpty,
			];
		}
		return [
			filterEq,
			filterNotEq,
			filterContains,
			filterNotContains,
			filterEmpty,
			filterNotEmpty,
		];
	}, [isNumber]);

	const {
		handleOptionChange,
		handleSubmit,
		handleValueChange,
		selectedOption,
		selectedValue,
	} = useFilter(options, initialSelected, operator, onSubmit, 'string');

	const handleChangeText = (e) => {
		handleValueChange(e, e.target.value);
	};

	// ! непонятно как сделать кнопку "добавить" для eq и notEq
	let uiNode;
	switch (selectedOption?.value) {
		case FILTER_CLAUSE.eq:
		case FILTER_CLAUSE.notEq:
		case FILTER_CLAUSE.moreThen:
		case FILTER_CLAUSE.lessThen:
		case FILTER_CLAUSE.contains:
		case FILTER_CLAUSE.notContains:
			uiNode = (
				<TextField value={selectedValue} onChange={handleChangeText} />
			);
			break;
		case FILTER_CLAUSE.inRange:
			uiNode = (
				<RangeField
					value={selectedValue}
					onChange={handleValueChange}
				/>
			);
			break;
	}

	return (
		<FilterPlate
			typeSelector={{
				value: selectedOption,
				selectOnly: true,
				disableClearable: true,
				onChange: handleOptionChange,
				options,
			}}
			uiNode={uiNode}
			onSubmit={handleSubmit}
			{...rest}
		/>
	);
};

FilterPlateCString.propTypes = {
	...FilterPlate.propTypes,
	isNumber: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	operator: PropTypes.string,
};

export default FilterPlateCString;
